module.exports = __webpack_public_path__ + "static/img/hb_15-min.e1a2fb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_15-min.png
// module id = DKtq
// module chunks = 1